export const enum OnboardTypes {
  SELF = 1,
  HOSPITAL,
}

export const OnboardTypesMap = {
  [OnboardTypes.SELF.toString()]: 'Self',
  [OnboardTypes.HOSPITAL.toString()]: 'Hospital',
};
